(() => {
  let lastVariant = null;

  const formatJPY = (priceCents) => {
    if (typeof priceCents !== 'number') return '';
    return '¥' + Math.round(priceCents / 100).toLocaleString('ja-JP');
  };

  const createEl = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text != null) el.textContent = text;
    return el;
  };

  const buildSinglePriceNodes = (variant) => {
    const isOnSale =
      typeof variant.compare_at_price === 'number' &&
      variant.compare_at_price > variant.price;

    const frag = document.createDocumentFragment();

    const sale = createEl('sale-price', isOnSale ? 'h4 text-on-sale' : 'h4 text-subdued');
    sale.appendChild(createEl('span', 'sr-only', 'セール価格'));
    sale.appendChild(document.createTextNode(formatJPY(variant.price)));
    sale.appendChild(createEl('span', 'text-sm', '（税込）'));
    frag.appendChild(sale);

    if (isOnSale) {
      const cmp = createEl('compare-at-price', 'h5 text-subdued line-through');
      cmp.appendChild(createEl('span', 'sr-only', '通常価格'));
      cmp.appendChild(document.createTextNode(formatJPY(variant.compare_at_price)));
      frag.appendChild(cmp);
    }

    return frag;
  };

  const isRangeDisplay = (priceListEl) => priceListEl.textContent.includes('〜');

  const replaceRangeWithSingle = (variant) => {
    document.querySelectorAll('.price-list--product').forEach((el) => {
      if (isRangeDisplay(el)) {
        el.replaceChildren(buildSinglePriceNodes(variant));
      }
    });
  };

  const initFromUrlVariant = () => {
    const url = new URL(location.href);
    const variantId = url.searchParams.get('variant');
    if (!variantId) return;

    const variantScript = document.querySelector('variant-picker script[data-variant]');
    if (!variantScript) return;
    try {
      const variant = JSON.parse(variantScript.textContent);
      if (variant && String(variant.id) === variantId) {
        lastVariant = variant;
        replaceRangeWithSingle(variant);
      }
    } catch (e) {
      // ignore
    }
  };
  initFromUrlVariant();

  document.addEventListener('variant:change', (e) => {
    const variant = e.detail && e.detail.variant;
    if (!variant) return;
    lastVariant = variant;
    replaceRangeWithSingle(variant);
  });

  const observeTargets = ['.product-info', 'product-sticky-bar'];
  observeTargets.forEach((selector) => {
    const target = document.querySelector(selector);
    if (!target) return;
    const observer = new MutationObserver(() => {
      if (lastVariant) replaceRangeWithSingle(lastVariant);
    });
    observer.observe(target, { childList: true, subtree: true });
  });
})();
